<template>
  <ul class="tabs-simple">
    <li
      v-for="(item, index) in tabs"
      :key="index"
      :class="{ active: item.name == curTab }"
      @click="curTab = item.name"
      :style="{
        fontSize: fontSize[size],
      }"
    >
      {{ item.label }}
    </li>
  </ul>
</template>

<script>
export default {
  name: "TabsSimple",
  props: {
    value: {
      default: "",
    },
    // 格式 [{label: 'lalala', name: 0}]
    tabs: {
      type: Array,
      default() {
        return [];
      },
    },
    // normal:font-size = 16px     small:font-size=14px
    size: {
      type: String,
      default: "normal",
    },
  },
  data() {
    return {
      curTab: "",
      fontSize: {
        normal: "16px",
        small: "14px",
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.curTab = val;
      },
    },
    curTab(val) {
      this.$emit("update:value", val);
      this.$emit("on-change", val);
    },
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
